import React from "react";
import { FaCheckCircle, FaExclamationCircle, FaTimesCircle } from "react-icons/fa"; // Import necessary icons

const SuccessModal = ({ isModalOpen, closeModal, message, type }) => {
  // Define the icons and colors based on the type
  const iconMapping = {
    success: <FaCheckCircle size={50} color="#28a745" />, // Green success icon
    error: <FaTimesCircle size={50} color="#dc3545" />, // Red error icon
    warning: <FaExclamationCircle size={50} color="#ffc107" />, // Yellow warning icon
  };
 
  const titleMapping = {
    success: "Success",
    error: "Error",
    warning: "Warning",
  };

  return (
    isModalOpen && (
      <div
        className={`modal show`}
        tabIndex="-1"
        style={{ display: "block" }} // Inline style to show the modal
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{titleMapping[type]}</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="d-flex justify-content-start align-items-center mb-3">
                <div className="me-3">
                  {iconMapping[type]} {/* Dynamic icon */}
                </div>
                <p className="mb-0">{message}</p> {/* Message next to the icon */}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-main py-18 px-40"
                onClick={closeModal}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default SuccessModal;
